"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMIT_TYPING_INDICATOR = void 0;
exports["default"] = emitTypingIndicator;
var EMIT_TYPING_INDICATOR = 'WEB_CHAT/EMIT_TYPING_INDICATOR';
exports.EMIT_TYPING_INDICATOR = EMIT_TYPING_INDICATOR;

function emitTypingIndicator() {
  return {
    type: EMIT_TYPING_INDICATOR
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJFTUlUX1RZUElOR19JTkRJQ0FUT1IiLCJlbWl0VHlwaW5nSW5kaWNhdG9yIiwidHlwZSJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL2VtaXRUeXBpbmdJbmRpY2F0b3IuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgRU1JVF9UWVBJTkdfSU5ESUNBVE9SID0gJ1dFQl9DSEFUL0VNSVRfVFlQSU5HX0lORElDQVRPUic7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGVtaXRUeXBpbmdJbmRpY2F0b3IoKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogRU1JVF9UWVBJTkdfSU5ESUNBVE9SXG4gIH07XG59XG5cbmV4cG9ydCB7IEVNSVRfVFlQSU5HX0lORElDQVRPUiB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEscUJBQXFCLEdBQUcsZ0NBQTlCOzs7QUFFZSxTQUFTQyxtQkFBVCxHQUErQjtFQUM1QyxPQUFPO0lBQ0xDLElBQUksRUFBRUY7RUFERCxDQUFQO0FBR0QifQ==